import { CurrencyItemType } from "../../store/slices/currencyListSlice";

const getCurrencyIsoCodeByCurrencyId = (currencyList: CurrencyItemType[], currencyId: number) => {
    const index = currencyList.findIndex(w => w.currencyId == currencyId);

    if (index != -1) {
        return currencyList[index].currencyIsoCode;
    }
    return "949";
}

export default getCurrencyIsoCodeByCurrencyId;